export default __webpack_public_path__ + "static/screen-training-becdea527a43e912d8064d1ff36462d7.png";